import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { PermissionActionType } from '@/store/modules/permission/action-types';
import { useStore } from '@/store';
import { RouteConstants } from '@/models/constant';
import { newDebounce } from '@/utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const storeM = useStore();
    storeM.dispatch(PermissionActionType.ACTION_SET_ROUTES, RouteConstants.ADMIN_ROOT_DIRECTORY);
    /** **********************************防止elementplus 重复调用resize防抖******************************************************/
    const _ResizeObserver = window.ResizeObserver;
    if (_ResizeObserver) {
      window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback) {
          const debouncedCallback = newDebounce(callback, 100);
          super(debouncedCallback);
        }
      };
    }
    /******************************************************************************************/
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});